<template>
  <div>
    <div class="value pointer" :id="'date-field-' + uuid" tabindex="0">
      <with-close-icon
        class="chip-container d-flex align-items-center"
        @close="$emit('remove')"
        v-if="value"
      >
        <span class="py-1">{{ value }}</span>
      </with-close-icon>
      <span class="text-secondary pick-placeholder" v-else>Pick</span>
    </div>
    <b-popover
      ref="datePopover"
      custom-class="date-picker-filter-po"
      triggers="click blur"
      placement="bottom"
      :target="'date-field-' + uuid"
    >
      <date-picker :value="value" @input="onDateChange" />
    </b-popover>
  </div>
</template>

<script>
import DatePicker from '@/components/form/DatePicker'
import WithCloseIcon from '@/components/WithCloseIcon'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import { BPopover } from 'bootstrap-vue'

/**
 * This gives a date selector
 */
export default {
  name: 'DateSelect',
  props: ['value'],
  mixins: [ComponentIdMixin],
  components: {
    DatePicker,
    BPopover,
    WithCloseIcon
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onDateChange(value) {
      this.$refs.datePopover.$emit('close')
      this.$emit('change', value)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.value {
  padding: 2px 0 2px 10px;
  background-color: $quaternary;
  border-radius: 20px;

  &:hover,
  &[aria-describedby^='__bv_popover'] {
    background-color: $tertiary;
  }
}

.pick-placeholder {
  padding-right: 10px;
}
</style>

<style lang="scss">
.date-picker-filter-po .popover-body {
  padding: 0;
}
</style>
